import React from 'react';
import c from '../w.js';

const IconWarningFilled = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.87868 2.70705C11.0503 1.53547 12.9498 1.53548 14.1213 2.70705L21.2929 9.87862C22.4645 11.0502 22.4645 12.9497 21.2929 14.1213L14.1213 21.2928C12.9497 22.4644 11.0503 22.4644 9.87868 21.2928L2.70711 14.1213C1.53554 12.9497 1.53554 11.0502 2.70711 9.87862L9.87868 2.70705ZM11 7V13H13V7H11ZM11 15V17H13V15H11Z"
      }
    )
  )
);

export { IconWarningFilled };
